import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'
import { capitalizeText } from 'servos/textHelpers'

const locationAddress = (address1, address2) => {
  if (address2 == null) {
    return address1
  } else {
    return `${address1} ${address2}`
  }
}

const getFullAddress = (metaData) => {
  const {
    full_address,
    address_line_1,
    address_line_2,
    locality_name,
    postcode,
    state_territory,
    latitude,
    longitude,
  } = metaData

  return(`${locationAddress(address_line_1, address_line_2)}, ${locality_name}, ${postcode}, ${state_territory}`)
}

class AddressLookup extends React.Component {

  addressFinder = () => {
    this.widget = new AddressFinder.Widget(
      this.address,
      gon.services.address_finder_api_key,
      'AU', {
        "address_params": {
          "post_box": "0"
        },
        container: this.selectContainer,
      }
    );

    if (this.props.onChange !==undefined) {
      this.widget.on('result:select', (fullAddress, metaData) => {
        const {
          full_address,
          address_line_1,
          address_line_2,
          locality_name,
          postcode,
          state_territory,
          latitude,
          longitude,
        } = metaData

        this.address.value = getFullAddress(metaData)

        this.props.onChange({
          // ...metaData,
          full_address: getFullAddress(metaData),
          locationFullAddress: getFullAddress(metaData),
          locationPostcode: postcode,
          locationState: state_territory,
          locationAddress: locationAddress(address_line_1, address_line_2),
          locationSuburb: capitalizeText(locality_name),
          locationCountry: 'AU',
          coords: {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
          }
        })
      });
    }
  }

  componentDidMount() {
    this.initializeFinder()
  }

  componentDidUpdate() {
    this.initializeFinder()
  }

  initializeFinder() {
    if (this.widget == undefined && this.address && this.selectContainer) {
      this.addressFinder()
    }
  }

  onChange(value) {
    if (value.length == 0) {
      this.props.onChange({
        locationFullAddress: null,
        locationPostcode: null,
        locationState: null,
        locationAddress: null,
        locationSuburb: null,
        coords: {},
      })
    }
  }

  renderLabel() {
    const { label } = this.props;
    if (label !== undefined && label.length > 0) {
      return(<label>{label}</label>)
    }
  }

  placeholderText() {
    const { placeholder } = this.props;

    if (placeholder !== undefined && placeholder.length > 0) {
      return placeholder
    } else {
      return "e.g. 1 York Street, Sydney, NSW 2000"
    }
  }

  render() {
    const {
      errorMessage,
      size,
      defaultValue,
      inputGroupClass,
    } = this.props

    return(
      <div className={ `form-group ${ sizes.group[size] } ${ presenceErrorClass(errorMessage) } `}>
        { this.renderLabel() }
        <div className={ `input-group ${inputGroupClass}` } >
          <input
            className={`form-control ${ sizes.control[size] } ${ presenceErrorClass(errorMessage) }`}
            id='address-finder'
            ref={address => { this.address = address } }
            type="text"
            defaultValue={this.props.defaultValue}
            placeholder={ this.placeholderText() }
            onChange={ (e) => this.onChange(e.currentTarget.value) }
          />
          <div className="invalid-feedback">
            { errorMessage }
          </div>
        </div>
        <div ref={ el => { this.selectContainer = el }} className='address-select-container' />
      </div>
    )
  }
}

const sizes = {
  group: {
    large: 'form-group-lg',
  },
  control: {
    large: 'form-control-lg',
  }
}

export default AddressLookup;
